import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router";
import utils from "@utils";
import TimeHoverTooltip from "../../TimeHoverTooltip";

const OfficerNonRKPayInvoiceItemView = ({
	user,
	user: { TimeZoneId },
	item,
}) => {
	const { lang } = global;

	return (
		<div
			className="col-sm-12 job-item"
			key={`assignment_${item.JobAssignmentId}`}
		>
			<div className="row">
				<div className="col-xs-12 col-md-3 col-md-offset-3">
					<strong className="hidden-md hidden-lg">
						{lang.t("Job Name")}:{" "}
					</strong>
					<span className="hidden-md hidden-lg">
						<Link
							to={`/jobs/${item.JobEventId}`}
						>{`${item.JobEventTitle} (${item.JobEventId})`}</Link>
					</span>
					<strong className="hidden-xs hidden-sm">
						<Link
							to={`/jobs/${item.JobEventId}`}
						>{`${item.JobEventTitle} (${item.JobEventId})`}</Link>
					</strong>
					<em className="hidden-md hidden-lg padding-left-4">
						<small>{item.JobTitle}</small>
					</em>
					<br className="hidden-xs hidden-sm" />
					<em className="hidden-xs hidden-sm">
						{item.JobTitle}
					</em>
				</div>
				<div className="col-xs-12 col-md-3">
					<div className="card-only v-align">
						<strong>
							{lang.t("Date")} &amp; {lang.t("Time")}:{" "}
						</strong>
						<span className="padding-right-4 padding-left-4">
							{
								utils.splitDateTimeComponents(
									item.JobStartTime,
									TimeZoneId,
									user.UserPreferences ===
										"useMilitaryTime",
								).date
							}
						</span>
						<TimeHoverTooltip
							item={item}
							TimeZoneId={TimeZoneId}
							user={user}
						/>
					</div>
					<div className="hidden-xs hidden-sm">
						<p>
							{
								utils.splitDateTimeComponents(
									item.JobStartTime,
									TimeZoneId,
									user.UserPreferences ===
										"useMilitaryTime",
								).date
							}
						</p>
						<TimeHoverTooltip
							item={item}
							TimeZoneId={TimeZoneId}
							user={user}
						/>
					</div>
				</div>
				<div className="col-xs-12 col-md-1">
					<label
						className="card-only"
						htmlFor={`positionRate-${item.JobAssignmentId}`}
					>
						<strong>{`${lang.t("Rate")}`}: </strong>
					</label>
					<span className="hidden-md hidden-lg padding-left-5">
						{utils.currencyFormatter(item.Rate)}
					</span>
					<div className="hidden-xs hidden-sm">
						{utils.currencyFormatter(item.Rate)}
					</div>
				</div>
				<div className="col-xs-12 col-md-1">
					<label
						className="card-only"
						htmlFor={`positionHours-${item.JobAssignmentId}`}
					>
						<strong>{lang.t("Hours")}</strong>
					</label>
					<span className="hidden-md hidden-lg padding-left-5">
						{item.Hours}
					</span>
					<div className="hidden-xs hidden-sm">
						{item.Hours}
					</div>
				</div>
			</div>
		</div>
	)
}

OfficerNonRKPayInvoiceItemView.propTypes = {
	user: PropTypes.object,
	item: PropTypes.object,
};

OfficerNonRKPayInvoiceItemView.defaultProps = {
	user: {},
	item: {},
};

export default OfficerNonRKPayInvoiceItemView;
